import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';


function Navbar() {
    const location = useLocation();
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        const name = location.pathname;
        document.body.className = name.length> 1 ? name.substring(1) + "-body" : name.substring(1) + "index-body";
    }, [location]);

    const handleBurgerMenu = () => {
        setIsActive(prevState => !prevState);
        document.body.style.overflow = !isActive ? 'hidden' : '';
    };
  
 
    const closeMenu = () => {
        setIsActive(false);
        document.body.style.overflow = 'auto';
    };

    return (
        
        <header className="header">
 
     
            <div className="header w-100">
                <div className="left-side">
                    <div className="main-title"><Link to="/">COMTECH DMCC</Link></div>
                    <div className="title">"The Ultimate Technology Solution"</div>
                </div>

                <div className={`right-side ${isActive ? 'active' : ''}`}>
                    <ul className={`right-side-li ${isActive ? 'right-side-small' : ''}`} >
                        <i className="fa-solid fa-xmark close" onClick={handleBurgerMenu}></i>
                        <div className={`sidebar-title ${isActive ? 'sidebar-title-small' : ''}`}>
                            <div>
                                <div className="main-title"><a href="index.html">COMTECH DMCC</a></div>
                                <div className="title">"The Ultimate Technology Solution"</div>
                            </div>
                        </div>
                        <li className={`${location.pathname === "/home" ? "active" : ""}`}><Link to="/home" onClick={closeMenu}>Home</Link></li>
                        <li className={`${location.pathname === "/aboutus" ? "active" : ""}`}><Link to="/aboutus" onClick={closeMenu}>About Us</Link></li>
                        <li className={`${location.pathname === "/services" ? "active" : ""}`}><Link to="/services" onClick={closeMenu}> Services</Link></li>
                        <li className={`${location.pathname === "/contactus" ? "active" : ""}`}><Link to="/contactus" onClick={closeMenu}>Contact Us</Link></li>
                    </ul>
                </div>
                <div className={`burger  ${isActive ? 'burger-active' : ''}`}>
                    <i className="fa-solid fa-bars"  onClick={handleBurgerMenu}></i>
                </div>
            </div>
        </header>
    );
}

export default Navbar;
